import { styled } from '@styles/stitches';

export const Container = styled('div', {
  width: '100%',

  '@bp2': {
    width: 350,
  },
});
